import './PlanLengthSwitch.scss';
import { PlanLength } from "../util/types";

interface Props {
  planLength: PlanLength,
  setPlanLength: (planLength: PlanLength) => void
}

export default function PlanLengthSwitch({ planLength, setPlanLength }: Props) {
  return <div className="switch-container">
    <div className={`${planLength === "monthly" ? "active" : ""}`} onClick={() => setPlanLength("monthly")}>Monthly</div>
    <div className={`${planLength === "annual" ? "active" : ""}`} onClick={() => setPlanLength("annual")}>Annual</div>
  </div>;
}
